export default "__VITE_ASSET__B9KzbSn8__"